export const INDIAN_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
  "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
  "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
  "Delhi", "Jammu and Kashmir", "Ladakh", "Puducherry",
];

export const TAX_REGIMES = [
  { value: "old", label: "Old Tax Regime" },
  { value: "new", label: "New Tax Regime" },
];

export const DECLARATION_STATUSES = ["Pending", "Submitted", "Approved", "Rejected"];
export const PROOF_STATUSES = ["Pending", "Verified", "Rejected"];

export const QUARTERS = [
  { id: "Q1", label: "Q1", period: "Apr – Jun" },
  { id: "Q2", label: "Q2", period: "Jul – Sep" },
  { id: "Q3", label: "Q3", period: "Oct – Dec" },
  { id: "Q4", label: "Q4", period: "Jan – Mar" },
];

export const DEFAULT_TDS_CONFIG = {
  deductor: {
    tanNumber: "",
    deductorName: "",
    legalEntityName: "",
    address: "",
    state: "",
    pinCode: "",
    contactPerson: "",
    email: "",
    mobile: "",
  },
  regime: {
    enableOldRegime: true,
    enableNewRegime: true,
    defaultRegime: "new",
    allowRegimeChange: true,
    regimeChangeDeadline: "",
  },
  calculation: {
    annualizedProjection: true,
    considerPreviousEmployer: true,
    considerBonus: true,
    considerVariablePay: true,
    considerArrears: true,
    autoRecalculateTds: true,
  },
  form16: {
    signatoryName: "",
    designation: "",
    place: "",
    digitalSignature: null,
    digitalSignatureName: "",
  },
  windows: {
    declarationStart: "",
    declarationEnd: "",
    proofStart: "",
    proofEnd: "",
  },
  quarterlyReturns: QUARTERS.map((q) => ({
    quarter: q.id,
    status: "Pending",
    filedDate: "",
    acknowledgementNumber: "",
  })),
};

export const SAMPLE_EMPLOYEES = [
  {
    id: "emp-001",
    code: "EMP001",
    name: "Priya Sharma",
    regime: "new",
    declarationStatus: "Approved",
    proofStatus: "Verified",
    monthlyTds: 12500,
    grossIncome: 1500000,
    exemptions: { section80C: 150000, section80D: 25000, hra: 0, homeLoan: 0 },
  },
  {
    id: "emp-002",
    code: "EMP002",
    name: "Rahul Verma",
    regime: "old",
    declarationStatus: "Submitted",
    proofStatus: "Pending",
    monthlyTds: 8200,
    grossIncome: 960000,
    exemptions: { section80C: 120000, section80D: 15000, hra: 84000, homeLoan: 0 },
  },
  {
    id: "emp-003",
    code: "EMP003",
    name: "Anita Desai",
    regime: "new",
    declarationStatus: "Pending",
    proofStatus: "Pending",
    monthlyTds: 4500,
    grossIncome: 720000,
    exemptions: { section80C: 0, section80D: 0, hra: 0, homeLoan: 0 },
  },
  {
    id: "emp-004",
    code: "EMP004",
    name: "Karthik Nair",
    regime: "old",
    declarationStatus: "Approved",
    proofStatus: "Verified",
    monthlyTds: 18500,
    grossIncome: 2100000,
    exemptions: { section80C: 150000, section80D: 25000, hra: 120000, homeLoan: 200000 },
  },
  {
    id: "emp-005",
    code: "EMP005",
    name: "Sneha Patel",
    regime: "new",
    declarationStatus: "Rejected",
    proofStatus: "Rejected",
    monthlyTds: 6800,
    grossIncome: 840000,
    exemptions: { section80C: 80000, section80D: 10000, hra: 0, homeLoan: 0 },
  },
];

export function formatINR(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "₹0";
  return `₹${n.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}

export function computeTaxableIncome(gross, exemptions) {
  const totalExemptions = Object.values(exemptions || {}).reduce((s, v) => s + (v || 0), 0);
  return Math.max(0, gross - totalExemptions);
}

export function estimateAnnualTax(taxableIncome, regime = "new") {
  if (regime === "new") {
    if (taxableIncome <= 300000) return 0;
    if (taxableIncome <= 600000) return (taxableIncome - 300000) * 0.05;
    if (taxableIncome <= 900000) return 15000 + (taxableIncome - 600000) * 0.1;
    if (taxableIncome <= 1200000) return 45000 + (taxableIncome - 900000) * 0.15;
    if (taxableIncome <= 1500000) return 90000 + (taxableIncome - 1200000) * 0.2;
    return 150000 + (taxableIncome - 1500000) * 0.3;
  }
  const stdDeduction = 50000;
  const adjusted = Math.max(0, taxableIncome - stdDeduction);
  if (adjusted <= 250000) return 0;
  if (adjusted <= 500000) return (adjusted - 250000) * 0.05;
  if (adjusted <= 1000000) return 12500 + (adjusted - 500000) * 0.2;
  return 112500 + (adjusted - 1000000) * 0.3;
}
